/* eslint-disable react/jsx-no-undef */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { 
  Box, Drawer, IconButton, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Typography, Collapse
} from '@mui/material';
import { 
  ChevronLeft,
  HomeOutlined, ShoppingCartOutlined,
  ReceiptLongOutlined, Restaurant, 
  LocalPharmacy, Inventory2Outlined, Inventory,
  ExpandLess, ExpandMore, Category, LocalShipping,
  ShoppingBasket, ListAlt, LunchDining, LocalBar, LocalCafe,
  FitnessCenter, People, AttachMoney, Assignment, Schedule,
  ProductionQuantityLimits, Man, Settings,
  Bed, MyLocation, Place, MenuBook, Hotel,
  EmojiPeopleOutlined, BookOnline,
  BusinessOutlined, ManageAccountsOutlined,
  ViewList, Add, Sell, Person2Outlined, SubscriptOutlined,
  ReceiptOutlined, ManageHistory,
  ContentCut, Palette, Groups, Payments
} from '@mui/icons-material';
import FlexBetween from './FlexBetween';
import ConfigurationFidelite from 'scenes/Configuration/ConfigurationFidelite';

/* ===================== MODULES ===================== */
const ALL_MODULES = {
  dashboard: {
    text: "Dashboard",
    icon: <HomeOutlined />,
    path: "depot/dashboard",
    accessibleBy: ['all']
  },

  // depot: {
  //   text: "Dépot",
  //   icon: <ReceiptLongOutlined />,
  //   path: "depot",
  //   accessibleBy: ['depot', 'admin', 'proprietaire', 'manager'],
  //   // subItems : [{
  //   //   text : "Succursale",
  //   //   icon : <BusinessOutlined/>,
  //   //   path : "depot/succursale",
  //   //   accessibleBy: ['admin', 'proprietaire', 'manager'],
  //   // }]
  // },
    Annexe: {
    text: "Annexe",
    icon: <BusinessOutlined />,
    path: "depot/succursale",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot', 'gym']
  },

    GestionStock: {
    text: "Gestion Stock",
    icon: <ManageHistory />,
    path: "stocks-succursale",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot', 'gym']
  },

  pharmacie: {
    text: "Pharmacie",
    icon: <LocalPharmacy />,
    path: "pharmacie",
    accessibleBy: ['pharmacie', 'admin']
  },

  restaurant: {
    text: "Restaurant / Hôtel",
    icon: <Restaurant />,
    path: "restaurant",
    accessibleBy: ['restaurant', 'admin','proprietaire', 'manager'],
    // Un libellé = une page. « Boissons » apparaissait deux fois : une fois pour
    // les catégories, une fois pour la carte. Les catégories vivent désormais
    // sous leur objet, avec un nom explicite.
    subItems: [
      {
        text: "Carte",
        icon: <MenuBook />,
        children: [
          { text: "Plats", icon: <LunchDining />, path: "restaurant/plats" },
          { text: "Boissons", icon: <LocalCafe />, path: "restaurant/boissons" },
          { text: "Catégories de plats", icon: <Category />, path: "restaurant/categories-menu" },
          { text: "Catégories de boissons", icon: <LocalBar />, path: "restaurant/categories-boissons" }
        ]
      },
      {
        text: "Hôtel",
        icon: <Hotel />,
        children: [
          { text: "Chambres", icon: <Bed />, path: "restaurant/chambres" },
          { text: "Locations", icon: <MyLocation />, path: "restaurant/locations" },
          { text: "Réservations", icon: <Place />, path: "restaurant/reservations" }
        ]
      },
      { text: "Commandes", icon: <ReceiptOutlined />, path: "restaurant/commandes" },
      { text: "Employés", icon: <EmojiPeopleOutlined />, path: "restaurant/employes" },
      { text: "Dépenses", icon: <BookOnline />, path: "restaurant/depenses" }
    ]
  },

  studio: {
    text: "Studio",
    icon: <ContentCut />,
    path: "studio",
    accessibleBy: ['studio', 'admin', 'proprietaire', 'manager'],
    subItems: [
      {
        text: "Catalogue",
        icon: <MenuBook />,
        children: [
          { text: "Prestations", icon: <ContentCut />, path: "studio/prestations" },
          { text: "Designs", icon: <Palette />, path: "studio/designs" },
          { text: "Sections", icon: <Category />, path: "studio/categories" }
        ]
      },
      { text: "Boissons & accessoires", icon: <LocalCafe />, path: "studio/articles" },
      { text: "Tickets", icon: <ReceiptOutlined />, path: "studio/tickets" },
      { text: "Prestataires", icon: <Groups />, path: "studio/prestataires" },
      { text: "Clients", icon: <People />, path: "studio/clients" },
      { text: "Dépenses", icon: <Payments />, path: "studio/depenses" }
    ]
  },

  shop: {
    text: "Shop",
    icon: <ShoppingCartOutlined />,
    path: "shop",
    accessibleBy: ['shop', 'admin']
  },

  gym: {
    text: "GYM",
    icon: <FitnessCenter />,
    path: "gym",
    accessibleBy: ['gym', 'admin'],
    subItems: [
      { text: "Clients", icon: <People />, path: "gym/clients" },
      { text: "Abonnements", icon: <Assignment />, path: "gym/abonnements" },
      { text: "Paiements", icon: <AttachMoney />, path: "gym/paiements" },
      { text: "Coachs", icon: <Man />, path: "gym/coaches" },
      { text: "Produits", icon: <ProductionQuantityLimits />, path: "gym/shop-products" },
      { text: "Planning", icon: <Schedule />, path: "gym/emploi-du-temps" },
      { text: "Settings", icon: <Settings />, path: "gym/settings" }
    ]
  },

  inventaire: {
    text: "Inventaire",
    icon: <Inventory2Outlined />,
    path: "inventaire",
    accessibleBy: ['admin', 'shop', 'restaurant', 'depot', 'pharmacie'],
    subItems: [
      { text: "Catégories", icon: <Category />, path: "categories" },
      {
        text: "Fournisseurs",
        icon: <LocalShipping />,
        children: [
          { text: "Liste", icon: <ListAlt />, path: "fournisseurs/liste" },
          { text: "Achats", icon: <ShoppingBasket />, path: "fournisseurs/achats" }
        ]
      },
      { text: "Clients", icon: <People />, path: "clients" },
       {
      text: "Ventes",
      icon: <ReceiptOutlined />,
      children: [
        // { text: "Nouvelle vente", icon: <Add />, path: "ventes" },
        { text: "Historique Vente", icon: <ManageHistory />, path: "ventes" }
      ]
    },
      { text: "Produits", icon: <Inventory />, path: "produits" }
    ]
  },
 Manage_User: {
    text: "Manage User",
    icon: <ManageAccountsOutlined />,
    path: "depot/manage-user",
    // 'studio' manquait : un propriétaire de salon n'avait aucun moyen de créer
    // la caissière qui fera les tickets.
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot', 'gym', 'restaurant', 'studio'],
    // subItems: [
    //   {
    //     text: "Manager",
    //     icon: <Person2Outlined />,
    //     children: [
    //       { text: "Listes", icon: <ViewList />, path: "depot/manage-user/manager/list" },
    //       { text: "Ajouter", icon: <Add />, path: "depot/manage-user/manager/add" }
    //     ]
    //   },
    //   {
    //     text: "Caissier",
    //     icon: <Sell />,
    //     children: [
    //       { text: "Listes", icon: <ViewList />, path: "depot/manage-user/caissier/list" },
    //       { text: "Ajouter", icon: <Add />, path: "depot/manage-user/caissier/add" }
    //     ]
    //   },
    //   {
    //     text: "Proprietaire",
    //     icon: <BusinessOutlined />,
    //     children: [
    //       { text: "Listes", icon: <ViewList />, path: "depot/manage-user/proprietaire/list" },
    //       { text: "Ajouter", icon: <Add />, path: "depot/manage-user/proprietaire/add" }
    //     ]
    //   },
      
    // ]
  },
    Abonnement: {
    text: "Abonnement",
    icon: <SubscriptOutlined />,
    path: "abonnements",
    accessibleBy: ['all']
  },

   Session: {
    text: "Session",
    icon: <Schedule />,
    path: "sessions-caisse",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot'],
    subItems : [{
      text : "Liste",
      icon : <ViewList/>,
      path : "depot/sessions-caisse",
      accessibleBy: ['admin', 'proprietaire', 'manager', 'depot'],
    }]
  },


    ConfigurationFidelite: {
    text: "Configuration",
    icon: <Settings />,
    path: "config-fidelite",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot', 'gym']
  },
};

/* ===================== SIDEBAR ===================== */
const Sidebar = ({ drawerWidth, isSidebarOpen, setIsSidebarOpen, isNonMobile }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [openSubmenu, setOpenSubmenu] = useState({});

  const user = useSelector((state) => state.global.user);
  const currentUser = user || JSON.parse(localStorage.getItem('user') || '{}');
  const userModule = currentUser.module_actif?.toLowerCase() || 'default';

  /**
   * Dérouler d'office le module de l'utilisateur.
   *
   * L'état d'ouverture était codé en dur (`restaurant` et `gym`) : sur un
   * compte mono-module autre que ceux-là, on se connectait sur une barre
   * latérale entièrement repliée, sans rien à cliquer. On l'ouvre donc à
   * partir du module actif — ou du module de l'URL, pour un admin qui passe
   * de l'un à l'autre — et on ouvre aussi le sous-groupe qui contient la page
   * affichée.
   */
  useEffect(() => {
    const segment = pathname.split('/').filter(Boolean)[0];
    const aOuvrir = {};

    Object.values(ALL_MODULES).forEach((module) => {
      if (!module.subItems?.length) return;
      if (module.path !== userModule && module.path !== segment) return;

      aOuvrir[module.path] = true;

      module.subItems.forEach((sub) => {
        if (sub.children?.some((child) => `/${child.path}` === pathname)) {
          aOuvrir[sub.text] = true;
        }
      });
    });

    // Fusion : on ne referme jamais ce que l'utilisateur a ouvert à la main
    setOpenSubmenu((prev) => ({ ...prev, ...aOuvrir }));
  }, [pathname, userModule]);

  const handleToggle = (key) => {
    setOpenSubmenu(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const isModuleAccessible = (module) => {
    if (userModule === 'admin') return true;
    if (module.accessibleBy?.includes('all')) return true;
    return module.accessibleBy?.includes(userModule);
  };

  const renderModuleItem = (module) => {
    const hasSubItems = module.subItems?.length > 0;
    const isRestaurant = module.path === "restaurant";

    return (
      <React.Fragment key={module.path}>
        <ListItem disablePadding>
          <ListItemButton
onClick={() =>
  hasSubItems
    ? handleToggle(module.path)
    : navigate(`/${module.path}`)
}

            sx={{ color: "#fff" }}
          >
            <ListItemIcon sx={{ color: "#fff", ml: "1.5rem" }}>
              {module.icon}
            </ListItemIcon>
            <ListItemText primary={module.text} />
            {hasSubItems && !isRestaurant &&
              (openSubmenu[module.path] ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </ListItem>

        {hasSubItems && (
<Collapse
  in={openSubmenu[module.path]}
  timeout="auto"
  unmountOnExit
>

            <List disablePadding>
              {module.subItems.map(sub => (
                <React.Fragment key={sub.text}>
                  <ListItemButton
                    sx={{ pl: 6, color: "#fff" }}
                    onClick={() =>
                      sub.children
                        ? handleToggle(sub.text)
                        : navigate(`/${sub.path}`)
                    }
                  >
                    <ListItemIcon sx={{ color: "#fff" }}>
                      {sub.icon}
                    </ListItemIcon>
                    <ListItemText primary={sub.text} />
                    {sub.children &&
                      (openSubmenu[sub.text] ? <ExpandLess /> : <ExpandMore />)}
                  </ListItemButton>

                  {sub.children && (
                    <Collapse in={openSubmenu[sub.text]} timeout="auto">
                      <List disablePadding>
                        {sub.children.map(child => (
                          <ListItemButton
                            key={child.path}
                            sx={{ pl: 8, color: "#fff" }}
                            onClick={() => navigate(`/${child.path}`)}
                          >
                            <ListItemIcon sx={{ color: "#fff" }}>
                              {child.icon}
                            </ListItemIcon>
                            <ListItemText primary={child.text} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
              ))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  return (
    <Drawer
      open={isSidebarOpen}
      variant="persistent"
      anchor="left"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          backgroundColor: "#000",
          color: "#fff"
        }
      }}
    >
      <Box m="1.5rem">
        <FlexBetween>
          <Typography variant="h4" fontWeight="bold">
            SGPME
          </Typography>
          {!isNonMobile && (
            <IconButton
              onClick={() => setIsSidebarOpen(false)}
              sx={{ color: "#fff" }}
            >
              <ChevronLeft />
            </IconButton>
          )}
        </FlexBetween>
      </Box>

      <List>
        {Object.values(ALL_MODULES)
          .filter(isModuleAccessible)
          .map(renderModuleItem)}
      </List>
    </Drawer>
  );
};

export default Sidebar;
